import {Component, Emit} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {DocumentViewModel} from './document.viewmodel';
import {DOCUMENT_MODULE_NAMESPACE, DOCUMENT_SET_DOCUMENT} from '../../../../store/document';
import {IDocument} from '../../../../models/documents/document';
import {BLOCK_GET_BLOCK, BLOCK_GET_BLOCKS_BYQUERY, BLOCK_MODULE_NAMESPACE} from '../../../../store/block';
import {APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE, APARTMENT_MODULE_NAMESPACE} from '../../../../store/apartment';
import {SEARCH_AUTOCOMPLETE, SEARCH_MODULE_NAMESPACE, SEARCH_REQUEST_BYID} from '../../../../store/search';
import {ActivityStatus, CrudStatus, SearchEntities} from '../../../../common/enums';
import {IBMMeetingDetailViewModel} from "../../../../models/bm/bm-meeting-detail.viewmodel";
import {BM_EDIT_PLAN_BY_FIELD, BM_GET_PLAN_BY_PARAMS, BM_MODULE_NAMESPACE} from "../../../../store/building-monitor/bm-types.store";
import {BMPlanEditedViewModel} from "../../../../models/bm/bm-plan-edited.viewmodel";

const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const BMStore = namespace(BM_MODULE_NAMESPACE)

@Component
class BMPlanModalVertical extends DocumentViewModel {
  dtBlocks: any[]
  dtApartments: any[]
  dtEntities: any[]
  dtPlans: any[]
  dtRules: {
    typesRules?: any,
    attachmentRules?: any,
    blockRules?: any,
    apartmentRules?: any
  }

  constructor() {
    super()
    this.dtBlocks = []
    this.dtApartments = []
    this.dtEntities = []
    this.dtRules = {}
    this.dtPlans = []
  }

  @DocumentStore.Getter document: IDocument;
  @DocumentStore.Getter documentTypes: any[]
  @DocumentStore.Getter documentCrudActionStatus: CrudStatus
  @BMStore.Getter bmMeeting: {
    activityStatus: ActivityStatus,
    data: IBMMeetingDetailViewModel
  };
  @BMStore.Getter bmPlanEdited: BMPlanEditedViewModel

  @BlockStore.Action(BLOCK_GET_BLOCKS_BYQUERY)
  storeGetBlocksByQuery: (query: string) => Promise<any>
  @BlockStore.Action(BLOCK_GET_BLOCK)
  storeGetBlockBy: (id: number) => Promise<any>
  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (payload?: any) => Promise<any>
  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (
    payload: { entity?: SearchEntities | SearchEntities[], query?: string, limit?: number, apartment?: number[], block?: number[] }
  ) => Promise<any>;
  @SearchStore.Action(SEARCH_REQUEST_BYID)
  storeGetEntityById: (entityId: number) => Promise<any>

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT)
  storeSetDocumentByValue: (payload?: IDocument) => void
  @BMStore.Mutation(BM_EDIT_PLAN_BY_FIELD)
  storeSetPlanByField: (payload: { [key: string]: any }) => void
  @BMStore.Action(BM_GET_PLAN_BY_PARAMS)
  storeGetPlanByParams: (payload: {block: number[], apartment: number[]}) => Promise<any>

  get lblSetting() {
    return {
      ...require('@/locales/document').default,
      ...require('@/locales/building-monitor').default,
      ...require('@/locales/validation-messages').default
    }
  }

  get hideAttachPlan (): boolean {
    return !!this.attachments
  }

  get showAttachPlan (): boolean {
    return !this.attachments
  }

  get showImportPlan(): boolean {
    return !this.mediaPlan
  }

  get hideImportPlan (): boolean {
    return !!this.mediaPlan
  }

  get mediaPlan (): number {
    return this.bmPlanEdited.fk_plan_media
  }

  set mediaPlan (mediaId:number) {
    let plan = this.dtPlans.find(x => x.id === mediaId)
    this.getImageSize(plan.link)
      .then(imageSize => {
        this.mediaWidth = imageSize.width
        this.mediaHeight = imageSize.height
      })
    this.storeSetPlanByField({ fk_plan_media: mediaId })
  }

  get mediaWidth (): number {
    return this.bmPlanEdited.width
  }

  set mediaWidth (width: number) {
    this.storeSetPlanByField({ width: width })
  }

  get mediaHeight (): number {
    return this.bmPlanEdited.height
  }

  set mediaHeight (height: number) {
    this.storeSetPlanByField({ height: height })
  }

  get coTypes () {
    return this.documentTypes
  }

  get coBlocks () {
    return this.dtBlocks
  }

  set coBlocks (value: any[]) {
    this.dtBlocks = value
  }

  get coApartments () {
    return this.dtApartments
  }

  set coApartments (value: any[]) {
    this.dtApartments = value.filter(item => !!item)
  }

  get coEntities () {
    return this.dtEntities
  }

  set coEntities (value) {
    this.dtEntities = value.map(entity => ({value: entity.id, text: entity.fullname}))
  }

  get isUpdateAction (): boolean {
    return this.documentCrudActionStatus === CrudStatus.Update
  }

  mounted () {
    /**
     * @description implement rules
     */
    this.dtRules = {
      typesRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.bmType)})
      ],
      blockRules: [
        v => (v && v.length > 0) || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.block)})
      ],
      apartmentRules: [
        v => (v && v.length > 0) || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.apartment)})
      ]
    }
    this.type = 25
    this.blocks = [this.bmMeeting.data.master.block.id]
    if (this.bmMeeting.data.master.apartment) {
      this.apartments = [this.bmMeeting.data.master.apartment.id]
    }
    this.getPlan()
    this.handleGetEntities(' ')
  }

  handleSearchChange (newVal: string) {
    if (newVal && newVal.length > 2) {
      this.storeGetBlocksByQuery(newVal)
        .then(response => {
          this.coBlocks = response
        })
        .catch(err => console.log('error fetching blocks options', err))
    }
  }

  @Emit('ChangeBlock')
  async handleBlockChange(query?: string) {
    await this.handleFetchApartments(query)
  }

  handleFetchApartments (query: string = '') {
    if (this.document.blocks && this.document.blocks.length)
      this.storeGetApartmentsAutocomplete({blockId: `${this.document.blocks.join()}`})
        .then(apartments => {this.coApartments = apartments.filter(apartment => !!apartment)})
  }

  handleGetEntities (query: string) {
    if (!query) return
    this.storeGetEntitySearch({entity: SearchEntities.Participant, query})
      .then(res => {this.coEntities = res})
  }

  getPlan () {
    let payload = {block: [this.bmMeeting.data.master.block.id], apartment: null}
    if (this.bmMeeting.data.master.apartment) {
      payload.apartment = [this.bmMeeting.data.master.apartment.id]
    }
    this.storeGetPlanByParams(payload)
      .then(response => {this.dtPlans = response.data})
  }

  async getImageSize (url): Promise<any> {
    return new Promise(resolve => {
      let img = new Image()
      img.onload = () => {
        return resolve({
          width: img.width,
          height: img.height
        })
      }
      img.src = url
    })
  }
}

export default BMPlanModalVertical



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-plan-modal-vertical/index.ts